"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _headers = require("../../../services/fetch/headers");
var _config = _interopRequireDefault(require("../../../consts/config"));
var _handlers = require("../../../services/fetch/handlers");
const checkEmail = ({
  email,
  brandId
}) => {
  const payload = {
    email,
    brand: brandId
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/user.exists`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(response => (0, _handlers.handleJSON)(response)).then(json => {
    return {
      emailVerified: json.verified,
      hasPassword: !json.passwordless,
      hasKiwiAccount: json.exists
    };
  });
};
var _default = checkEmail;
exports.default = _default;